export function antDecorator(Vue) {
  return Vue.directive('decorator', {});
}

export default {
  // just for tag
  install: function install(Vue) {
    antDecorator(Vue);
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/ant-design-vue/es/_util/FormDecoratorDirective.js
// module id = DRD8
// module chunks = 1